import { NavLink } from 'react-router-dom';

import { useGame } from '@/hooks/useGame';
import type { DashboardItem } from '@/models/dashboardItem';

import { GameImage } from '../gameMiniature';
import {
  Sidebar as ShadSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '../ui/sidebar';
import { GameSwitcher } from './gameSwitcher';

interface ProSidebarProps {
  items?: DashboardItem[];
}

const MenuItemWithChildren = ({ item }: { item: DashboardItem }) => {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild>
        <NavLink end to={item.link}>
          {item.icon} {item.label}
        </NavLink>
      </SidebarMenuButton>
      {item.items && item.items.length > 0 && (
        <SidebarMenuSub>
          {item.items.map((_item) => (
            <SidebarMenuSubItem key={_item.label}>
              <SidebarMenuSubButton asChild>
                <NavLink
                  end
                  to={`${item.link}/${_item.link}`}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  <span>{_item.icon}</span>
                  <span>{_item.label}</span>
                </NavLink>
              </SidebarMenuSubButton>
            </SidebarMenuSubItem>
          ))}
        </SidebarMenuSub>
      )}
    </SidebarMenuItem>
  );
};

export const AppSidebar = ({ items = [] }: ProSidebarProps) => {
  const game = useGame();
  return (
    <ShadSidebar>
      <SidebarHeader>
        <GameSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            {items.map((item) => (
              <MenuItemWithChildren key={item.label} item={item} />
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <div className="aspect-square size-36 mx-auto grid place-items-center ">
              <GameImage game={game} />
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </ShadSidebar>
  );
};
